export default __webpack_public_path__ + "static/media/veneer_bg.338ab26f.jpg";